import useSWR from "swr"
import useSWRMutation from "swr/mutation"
import { alfredService } from "@/services/alfred-service"
import type { AlfredGlobalConfig, UpdateAlfredGlobalConfigRequest } from "@/types/alfred-config"

// Shared SWR cache key for the singleton global config resource. Both hooks
// reference the same key so a successful PATCH automatically updates every
// component reading the config.
export const ALFRED_GLOBAL_KEY = ["alfred", "global"] as const

// Fetch the Alfred global config.
export function useAlfredGlobalConfig() {
  return useSWR(ALFRED_GLOBAL_KEY, () => alfredService.getGlobal(), {
    revalidateOnFocus: false,
  })
}

// PATCH the Alfred global config. Returns the updated config from the server.
export function useUpdateAlfredGlobalConfig() {
  return useSWRMutation(
    ALFRED_GLOBAL_KEY,
    async (
      _key: typeof ALFRED_GLOBAL_KEY,
      { arg }: { arg: UpdateAlfredGlobalConfigRequest },
    ): Promise<AlfredGlobalConfig> => {
      return alfredService.updateGlobal(arg)
    },
  )
}
